import { faArrowDownAZ, faStore } from "@fortawesome/free-solid-svg-icons"
import { Fragment, useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Link } from "react-router-dom"
import useFilter from "../../../../../hook/useFilter"
import useVariable from "../../../../../hook/useVariable"
import { logActions } from "../../../../../store/log-slice"
import InfoIcon from "../../../../InfoIcon"
import Pagination from "./pagination"
import Resort from "./resort"

export default function Filter({ children }) {


    const [showFilter, setShowFilter] = useState(false)

    let defaultlogcount = useSelector((state) => state.log.filterlogCount)
    let pagination = useSelector((state) => state.log.pagination)
    let sliceFilters = useSelector(state => state.log.filter)
    let sliceActions = logActions
    let sliceItems = useSelector(state => state.log.logs)

    const { doFilter } = useFilter()
    const { variableValue } = useVariable()

    const [paginationItems, setPaginationItems] = useState([])

    let dispatch = useDispatch()

    const [isMount, setIsMount] = useState(false)



    useEffect(() => {
        let items = []
        if (pagination) {
            pagination.map((item, key) => {

                items.push(<Pagination key={key} logs={item} index={key} />)
            })
        }

        setPaginationItems(items)
    }, [pagination])



    useEffect(() => {

        if (!isMount) {
            setIsMount(true)
            return
        }


        doFilter(sliceFilters, sliceItems, sliceActions)
    }, [sliceFilters])



    return <div className="p-3" >
        <Link className="btn btn-outline-secondary bgnt mb-2" to='/admin/product' ><InfoIcon icon={faStore} />New Product</Link>
        <div className="card shadow  bg-white rounded p-3 mb-3" style={{ cursor: 'pointer' }} onClick={() => {
            setShowFilter(!showFilter)
        }}  >

            <InfoIcon icon={faArrowDownAZ} size='xl' />

        </div>
        {showFilter &&
            <Fragment>
                <label>Pagination</label><select name="filterPostCount" defaultValue={sliceFilters.pagination} className="mb-2" onChange={(event) => {
                    let value = variableValue(event.target.value)
                    dispatch(logActions.setFilter({
                        key: 'pagination',
                        value
                    }))

                }} >
                    <option value='' >All</option>

                    {
                        defaultlogcount.map((item, key) => {

                            return <option key={key} value={item} >{item}</option>
                        })
                    }
                </select>

                <Resort type='id' name='ID' />
                <Resort type='method' name='Method' />
                <Resort type='user_id' name='UserId' />
                <Resort type='created_on' name='CreatedOn' />

            </Fragment>}
        <input type="text" name="filter-userid-method" className="mb-2" defaultValue={sliceFilters.search} placeholder="userid or method" onInput={(event) => {
            let value = variableValue(event.target.value)

            dispatch(logActions.setFilter({
                key: 'search',
                value
            }))


        }} />

        {children}

        <div className="pagination-container">{paginationItems}</div>

    </div>
}